<template>
  <div class="flex items-center justify-between pt-4 border-t border-gray-200">
    <div class="flex space-x-3">
      <button
        @click="$emit('sync-device', device.deviceId)"
        :disabled="!isOnline"
        class="px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Sync Device
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  device: {
    type: Object,
    required: true
  },
  isOnline: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['update-desired', 'sync-device'])

</script>